import { view } from '@esui/core';
import { HSTack } from '@esui/core/layout/index.js';
import { svg } from 'lit';
import { DemoPage, Section } from '../@demo/utils.js';
import { IconButton } from './index.js';

export const [IconButtonDemo] = view('icon-button-demo', {
  template() {
    const svgIcon = svg`
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
      `;

    return DemoPage(
      Section(
        '',
        HSTack(
          IconButton('code'),
          IconButton(svgIcon),
          IconButton('code').disabled(),
          IconButton('code').color('tomato').buttonSize('64px').iconSize('48px')
        ).gridGap('3rem')
      )
    );
  },
});
